import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  FormikWrapper,
  FormTextarea as Textarea,
} from '@uncinc/uncinc-react-kitchen-sink';

import Button from '../../Button';
import Popup from '../../Popup';

type Props = React.ComponentPropsWithRef<typeof Popup> & {
  loading?: boolean;
  onSubmit: (values: { body: string }) => void;
};

const FeedbackPopup = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    loading = false,
    onSubmit,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const initialValues = { body: '' };

  return (
    <Popup
      title={t('feedback.popup.title')}
      closeButtonText={t('buttons.close')}
      ref={ref}
      {...restProps}
    >
      <FormikWrapper
        initialValues={initialValues}
        enableReinitialize
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={(values, formProps) => {
          const { setSubmitting } = formProps;
          onSubmit(values as { body: string });
          setSubmitting(false);
        }}
      >
        <Textarea
          fieldName="body"
          value={initialValues.body}
          placeholder={t('feedback.popup.fields.body.placeholder')}
        />

        <Button htmlType="submit" buttonState={loading && 'disabled'}>
          {t('feedback.popup.submit')}
        </Button>
      </FormikWrapper>
    </Popup>
  );
});

export default FeedbackPopup;
